import React from "react"
import { Modal } from "@mui/material"
import { makeStyles } from "@material-ui/core/styles"
import PropTypes from "prop-types"
import { useState } from "react"
import i18n from "i18n"
import { YellowButton } from "common/buttons"
import useBudgetConfig, {
  BUDGET_CONFIG_TYPES,
  PREFERENCES,
} from "hooks/budgeting/useBudgetConfig"

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: "absolute",
    width: "630px",
    height: "490px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 6,
    maxHeight: "calc(100vh - 100px)",
    overflowY: "auto",
    overflowX: "hidden",
  },
}))

/**
 * Mapeo de valores de los inputs a las claves de preferencias.
 *
 * Los valores de los inputs (0, 1, 2, 3, 4, 5, 6) corresponden a las claves en `PREFERENCES`:
 *
 * - `0`: PREFERENCES.DATABASE
 * - `1`: PREFERENCES.CLIENT_PRICE
 * - `2`: PREFERENCES.DISCOUNT
 * - `3`: "objetivo" (Parece no estar en uso, pero se mantiene por compatibilidad)
 * - `4`: PREFERENCES.PROCEDENCE
 * - `5`: PREFERENCES.COST_PRICE
 * - `6`: PREFERENCES.REDUCED_COST
 */
const fieldMap = {
  0: PREFERENCES.DATABASE,
  1: PREFERENCES.CLIENT_PRICE,
  2: PREFERENCES.DISCOUNT,
  3: "objetivo",
  4: PREFERENCES.PROCEDENCE,
  5: PREFERENCES.COST_PRICE,
  6: PREFERENCES.REDUCED_COST,
}

const ModalPreferencias = ({ open, setOpen }) => {
  const [budgetConfig, updateConfig] = useBudgetConfig()

  const handleCheckBox = e => {
    const { checked, value } = e.target

    const name = fieldMap[value]

    if (!name) return // Si el valor no está en el mapeo, salir

    updateConfig(
      BUDGET_CONFIG_TYPES.PREFERENCES,
      name,
      checked, // Actualiza el valor con el estado del checkbox
    )
  }

  const [modalStyle] = useState(getModalStyle)
  const classes = useStyles()
  return (
    <Modal open={open} onClose={() => null}>
      <div style={modalStyle} className={classes.paper}>
        <div
          id="principalOptions"
          style={{ marginTop: "30px", marginBottom: "15px" }}
        >
          <p id="titles" style={{ textAlign: "center" }}>
            {i18n.t("Visibilidad de presupuesto")}
          </p>
          <p style={{ fontWeight: "300", textAlign: "center" }}>
            {i18n.t(
              "Customiza tus preferencias de visualización. Selecciona que opciones deseas ver en el presupuesto.",
            )}
          </p>

          <>
            <div
              className="inline"
              style={{ marginTop: "45px", marginBottom: "12px" }}
            >
              <p style={{ fontWeight: "300", fontFamily: "Helvetica" }}>
                {i18n.t("Precio de coste")}
              </p>

              <label className="switch" style={{ marginBottom: "0px" }}>
                <input
                  onChange={handleCheckBox}
                  className="form-check-input"
                  type="checkbox"
                  value="5"
                  id="flexCheckDefault"
                  style={{ marginRight: "10px" }}
                  checked={
                    budgetConfig[BUDGET_CONFIG_TYPES.PREFERENCES][
                      PREFERENCES.COST_PRICE
                    ]
                  }
                ></input>
                <span className="slider round"></span>
              </label>
            </div>
            <div className="separator"></div>
            <div
              className="inline"
              style={{ marginTop: "10px", marginBottom: "12px" }}
            >
              <p style={{ fontWeight: "300", fontFamily: "Helvetica" }}>
                {i18n.t("Márgen de partida")}
              </p>

              <label className="switch" style={{ marginBottom: "0px" }}>
                <input
                  onChange={handleCheckBox}
                  className="form-check-input"
                  type="checkbox"
                  value="0"
                  id="flexCheckDefault"
                  style={{ marginRight: "10px" }}
                  checked={
                    budgetConfig[BUDGET_CONFIG_TYPES.PREFERENCES][
                      PREFERENCES.DATABASE
                    ]
                  }
                ></input>
                <span className="slider round"></span>
              </label>
            </div>
            <div className="separator"></div>
            <div
              className="inline"
              style={{ marginTop: "10px", marginBottom: "12px" }}
            >
              <p style={{ fontWeight: "300", fontFamily: "Helvetica" }}>
                {i18n.t("Precio cliente")}
              </p>
              <label className="switch" style={{ marginBottom: "0px" }}>
                <input
                  onChange={handleCheckBox}
                  className="form-check-input"
                  type="checkbox"
                  value="1"
                  id="flexCheckDefault"
                  style={{ marginRight: "10px" }}
                  checked={
                    budgetConfig[BUDGET_CONFIG_TYPES.PREFERENCES][
                      PREFERENCES.CLIENT_PRICE
                    ]
                  }
                ></input>
                <span className="slider round"></span>
              </label>
            </div>
            <div className="separator"></div>
            <div
              className="inline"
              style={{ marginTop: "10px", marginBottom: "12px" }}
            >
              <p style={{ fontWeight: "300", fontFamily: "Helvetica" }}>
                {i18n.t("Descuentos")}
              </p>
              <label className="switch" style={{ marginBottom: "0px" }}>
                <input
                  onChange={handleCheckBox}
                  className="form-check-input"
                  type="checkbox"
                  value="2"
                  id="flexCheckDefault"
                  style={{ marginRight: "10px" }}
                  checked={
                    budgetConfig[BUDGET_CONFIG_TYPES.PREFERENCES][
                      PREFERENCES.DISCOUNT
                    ]
                  }
                ></input>
                <span className="slider round"></span>
              </label>
            </div>

            <div className="separator"></div>
            <div
              className="inline"
              style={{ marginTop: "10px", marginBottom: "12px" }}
            >
              <p style={{ fontWeight: "300", fontFamily: "Helvetica" }}>
                {i18n.t("Mostrar procedencia")}
              </p>
              <label className="switch" style={{ marginBottom: "0px" }}>
                <input
                  onChange={handleCheckBox}
                  className="form-check-input"
                  type="checkbox"
                  value="4"
                  id="flexCheckDefault"
                  style={{ marginRight: "10px" }}
                  checked={
                    budgetConfig[BUDGET_CONFIG_TYPES.PREFERENCES][
                      PREFERENCES.PROCEDENCE
                    ]
                  }
                ></input>
                <span className="slider round"></span>
              </label>
            </div>
            <div className="separator"></div>
            <div
              className="inline"
              style={{ marginTop: "10px", marginBottom: "12px" }}
            >
              <p style={{ fontWeight: "300", fontFamily: "Helvetica" }}>
                {i18n.t("preferences.reducedCost")}
              </p>
              <label className="switch" style={{ marginBottom: "0px" }}>
                <input
                  onChange={handleCheckBox}
                  className="form-check-input"
                  type="checkbox"
                  value="6"
                  id="flexCheckDefault"
                  style={{ marginRight: "10px" }}
                  checked={
                    budgetConfig[BUDGET_CONFIG_TYPES.PREFERENCES][
                      PREFERENCES.REDUCED_COST
                    ]
                  }
                ></input>
                <span className="slider round"></span>
              </label>
            </div>
          </>

          <div
            style={{
              width: "100%",
              justifyContent: "center",
              display: "flex",
              position: "relative",
              marginTop: "30px",
            }}
          >
            <YellowButton
              onClick={() => {
                setOpen(false)
              }}
              style={{
                justifyContent: "center",
                cursor: "pointer",
                display: "flex",
                position: "relative",
                textAlign: "center",
                width: "190px",
                height: "48px",
                paddingTop: "15px",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              {i18n.t("Guardar")}
            </YellowButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}

ModalPreferencias.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}
export default ModalPreferencias
